import {Col, message, Row, Spin, Tabs, Tag} from "antd";
import CustomerVerificationTable from "../../../components/admin/customerVerification/customerVerificationTable";
import {useEffect, useState} from "react";
import {WorkbasketTableDto} from "../../../dto/admin/WorkbasketTableDto";
import adminService from "../../../service/adminService";
import {ADMIN_VERIFICATION_TYPE} from "../../../util/Constants";
import {MSG_FAILED_TO_FETCH_PENDING_DETAIL_VERIFICATION_LIST_ERROR} from "../../../util/Messages";
import ErrorHandler from "../../../util/ErrorHandler";
import {UserOutlined} from "@ant-design/icons/lib";

const {TabPane} = Tabs;

const CustomerVerificationDetails = () => {
    const [pendingList, setPendingList] = useState<WorkbasketTableDto[]>([]);
    const [myAssignedList, setMyAssignedList] = useState<WorkbasketTableDto[]>([]);
    const [isLoading, setLoading] = useState(false);


    useEffect(() => {
        getDetailVerificationPendingList();
        getAssignedVerificationWorkListByUser();
    }, [])

    const getDetailVerificationPendingList = () => {
        setLoading(true)
        adminService.getPendingCustomerVerificationWorkList(ADMIN_VERIFICATION_TYPE.CUSTOMER_VERIFICATION).then(res => {
            if (res.data !== null) {
                setLoading(false)
                setPendingList(res.data.results.adminWorkBasketDtoList)

            } else {
                setLoading(false)
                message.error(MSG_FAILED_TO_FETCH_PENDING_DETAIL_VERIFICATION_LIST_ERROR).then();
            }
        }, (reason) => {
            setLoading(false)
            ErrorHandler.handleError(reason);
        })
    }

    const getAssignedVerificationWorkListByUser = () => {
        setLoading(true)
        adminService.getAssignedCustomerVerificationWorkListByUser(ADMIN_VERIFICATION_TYPE.CUSTOMER_VERIFICATION).then(res => {
            if (res.data !== null) {
                let results = res.data.results;
                setMyAssignedList(results.adminWorkBasketDtoList)
                setLoading(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_PENDING_DETAIL_VERIFICATION_LIST_ERROR).then();
                setLoading(false)
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setLoading(false)
        })
    }
    const tableUpdateFunc = (data: boolean) => {
        getDetailVerificationPendingList()
        getAssignedVerificationWorkListByUser()
        // setTableUpdate(data)
    }

    return (
        <Spin spinning={isLoading}>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='page-header-main-title-col'>
                    <h2 className='page-header-main-title'>
                        <div className='header_icon header-icon-center'>
                            <UserOutlined />
                        </div>
                         Customer Verification
                    </h2>
                </Col>
            </Row>

            <Row gutter={[16, 16]} className='margin_top_30 customer-verify-tables'>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Tabs type="card" defaultActiveKey={['1']}>
                        <TabPane tab={<>Pending in Verification <Tag color="blue">{pendingList?.length}</Tag></>}
                                 key="1">
                            <CustomerVerificationTable tableData={pendingList} isMyWorkBasket={false}
                                                       tableUpdateFunc={tableUpdateFunc}/>
                        </TabPane>
                        <TabPane tab={<> Waiting for Approval <Tag color="green">{myAssignedList?.length}</Tag></>}
                                 key="2">
                            <CustomerVerificationTable tableData={myAssignedList} tableUpdateFunc={tableUpdateFunc}
                                                       isMyWorkBasket={true}/>

                        </TabPane>
                    </Tabs>
                </Col>
            </Row>


        </Spin>


    )

}
export default CustomerVerificationDetails;

